import { render, staticRenderFns } from "./calendarMobile.vue?vue&type=template&id=1853d52f&"
import script from "./calendarMobile.js?vue&type=script&lang=js&"
export * from "./calendarMobile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1853d52f')) {
      api.createRecord('1853d52f', component.options)
    } else {
      api.reload('1853d52f', component.options)
    }
    module.hot.accept("./calendarMobile.vue?vue&type=template&id=1853d52f&", function () {
      api.rerender('1853d52f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendarMobile.vue"
export default component.exports